export const ERROR_MESSAGE = '呀，服务走丢了～';
